<template>
  <div id="grid-acuerdosPA">
    <v-flex>
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text"
          >Acuerdos preguntas abiertas</v-toolbar-title
        >
      </v-toolbar>
    </v-flex>
    <v-container grid-list-xl fluid>
      <v-layout>
        <carga-masiva-asincrona
          v-if="usuarioLoggedTipe != 'PROVEEDOR'"
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
          :tipoCarga="tipoCarga"
        ></carga-masiva-asincrona>
      </v-layout>
      <v-layout justify-center>
        <v-flex xs12 md6>
          <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            item-text="name"
            item-value="code"
            label="Nivel"
          ></v-select>
        </v-flex>
        <v-flex xs12 md8>
          <v-select
            v-model="tipoPruebaValue"
            :items="tipoPruebaSelect"
            label="Tipo Prueba"
          >
          </v-select>
        </v-flex>

        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="loadData()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headers"
              :items="datosPaginados"
              :page.sync="page"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              @page-count="pageCount = $event"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.nivel }}</td>
                  <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
                  <td class="text-xs-left">{{ props.item.asignatura }}</td>
                  <td class="text-xs-left">{{ props.item.forma }}</td>
                  <td class="text-xs-left">{{ props.item.cantidad }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-flex xs12 sm6>
              <v-text-field
                value=""
                label="Total de Registros"
                v-model="cantRegistros"
                disabled
              ></v-text-field>
            </v-flex>
            <div class="text-center pt-2">
              <v-pagination
                @input="changePage(page)"
                v-model="page"
                :length="pageCount"
                :total-visible="9"
                circle
              >
              </v-pagination>
            </div>

            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                :disabled="botonDescarga"
                :loading="loading"
                color="primary"
                @click="descarga()"
                >Descarga Acuerdos Preguntas abiertas<v-icon right dark
                  >folder</v-icon
                ></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </template>

          <v-dialog v-model="dialogLoading" persistent max-width="390">
            <loading-descarga></loading-descarga>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import CargaMasivaAsincrona from "@/components/CargaMasivaAsincrona.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-acuerdosPA",

  components: {
    AlertEmpty,
    Loading,
    CargaMasivaAsincrona,
    LoadingDescarga,
  },
  props: {},

  data() {
    return {
      botonDescarga: true,
      loading: false,
      alerta: false,
      dialogLoading: false,
      id: "",
      totalRegistro: "",
      idContrato: "",
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "" },
        { text: "Tipo Prueba", sortable: false, value: "" },
        { text: "Asignatura", sortable: false, value: "" },
        { text: "Forma", sortable: false, value: "" },
        { text: "Cantidad", sortable: false, value: "" },
      ],
      itemsAcuerdos: [],
      idUserLogged: "",
      //filtros
      nivelSelect: [],
      nivelValue: null,
      tipoPruebaSelect: [],
      tipoPruebaValue: null,
      //----CARGA MASIVA---
      apiValidateDocument: "/preguntasAbiertas/preProcessFileAcuerdos",
      apiSaveDocument: "/preguntasAbiertas/saveFileMassiveAcuerdos",
      apiDownloadDocument: "/preguntasAbiertas/downloadTemplateAcuerdos/",
      templateTitle: "PlantillaAcuerdosPreguntasAbiertas",
      tipoCarga: "CSV",

      page: 1,
      pageCount: 0,
      datosPaginados: [],
      paginaActual: 1,
      cantRegistros: 0,
      rowsPerPageItems: [20],
      pagination: {
        page: 1,
        rowsPerPage: 50,
        pages: 0,
      },
      totalPages: 0,
      totalRegistros: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;
      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },

  created() {
    // console.log("acuerdoPreguntas");

    this.idContrato = this.$store.getters.contratoStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;

    this.loadData();
  },
  mounted() {},
  computed: {},
  methods: {
    descarga() {
      this.dialogLoading = true;
      let fileName = "Descarga_acuerdos_PA.xlsx";

      var url = "/preguntasAbiertas/descargaAcuerdos";
      this.body = {
        idContrato: this.idContrato,
        nivel: this.nivelValue,
        tipoPrueba: this.tipoPruebaValue,
      };
      axios
        .post(url, this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadAcuerdosPA() {
      this.body = {
        nivel: this.nivelValue,
        tipoPrueba: this.tipoPruebaValue,
        idContrato: this.idContrato,
        pageSize: 20,
        pageNumber: this.page,
      };
      return await axios
        .post("/preguntasAbiertas/getResumenAcuerdos/", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;

      this.itemsAcuerdos = await this.loadAcuerdosPA();

      if (this.itemsAcuerdos.length > 0) {
        this.cantRegistros = this.itemsAcuerdos.length;
        this.pageCount = Math.ceil(
          this.itemsAcuerdos.length / this.rowsPerPageItems
        );
        this.getDataPagina(this.page);

        this.loadNivelSelect();
        this.loadTipoPruebaSelect();
        this.alerta = false;
        this.botonDescarga = false;
      } else {
        this.alerta = true;
        this.botonDescarga = true;
      }
      this.loading = false;
    },
    loadNivelSelect() {
      let niv = [];
      this.itemsAcuerdos.forEach(function (c) {
        let index = niv.findIndex((x) => x.nivel == c.nivel);
        if (index === -1) {
          if (c.nivel != null && c.nivel != "") {
            niv.push(c.nivel);
          }
        }
      });
      this.nivelSelect = niv;
    },
    loadTipoPruebaSelect() {
      let tip = [];
      this.itemsAcuerdos.forEach(function (d) {
        let index = tip.findIndex((x) => x.tipoPrueba == d.tipoPrueba);
        if (index === -1) {
          tip.push(d.tipoPrueba);
        }
      });
      this.tipoPruebaSelect = tip;
    },
    clear() {
      this.nivelValue = null;
      this.tipoPruebaValue = null;
      this.loadData();
    },

    // paginacion
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      console.log(this.page);
      this.getDataPagina(this.page);
    },
    getDataPagina(noPagina) {
      this.paginaActual = noPagina;
      this.datosPaginados = [];

      let ini = noPagina * this.rowsPerPageItems - this.rowsPerPageItems;
      let fin = noPagina * this.rowsPerPageItems;
      this.datosPaginados = this.itemsAcuerdos.slice(ini, fin);
    },
    getDataFull() {
      this.datosPaginados = [];
      this.page = 1;
      this.datosPaginados = this.itemsAcuerdos.slice(
        0,
        this.itemsAcuerdos.length
      );
    },
  },
};
</script>
